<template>
    <ListingSettingsHeader
        :totalResults="totalEmails"
        :columns="columns"
        :enableColumnsSettings="false"
        :displayTotalResults="displayTotalResults"
        :searchValue="searchValue"
        :searchable="searchable"
        :refreshable="refreshable"
        :customTotalResultsLabel="customTotalResultsLabel"
        @search="handleSearch"
        @refresh="handleRefresh"
    />
</template>
<script>
import ListingSettingsHeader from 'vcomponents/common/listing/header/ListingSettingsHeader.vue';
export default {
    components: {
        ListingSettingsHeader,
    },
    props: {
        columns: {
            type: Array,
            required: true,
        },
        totalEmails: {
            type: Number,
            required: true,
        },
        displayTotalResults: {
            type: Boolean,
            default: true,
        },
        searchValue: {
            type: String,
            default: '',
        },
        searchable: {
            type: Boolean,
            default: false,
        },
        refreshable: {
            type: Boolean,
            default: false,
        },
        customTotalResultsLabel: {
            type: String,
            default: '',
        },
    },
    methods: {
        handleRefresh() {
            this.$emit('refresh');
        },
        handleSearch(newSearchValue) {
            this.$emit('search', newSearchValue);
        },
    },
};
</script>
